import React from 'react';

import { ImExit } from 'react-icons/im';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { handleLogout } from '~/store/modules/Logout/action';

import './styles.css';

function Logout() {
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <ImExit
      color="#fff"
      className="exit"
      onClick={() => dispatch(handleLogout(history))}
      size={18}
    />
  );
}

export default Logout;
